import { DrawerItem } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import DinamicServerNavigation from "@/components/ServerElements/components/DinamicServerNavigation";
import {
  SpaceDashboard,
  MapsHomeWork,
  Receipt
} from "@mui/icons-material";
import { RootState } from "@/store";
import ContractationListItems from "../../CustomItems/ContractationListItems";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const UngroupedSideBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const params = useParams();
  const { pathname } = useLocation();
  const newCustomer = useSelector((state: RootState) => state.auth.newCustomer);

  const firstContractPath = `common:url.contracts.${Settings.features.displayTypes.filter(type => type !== "multipoint")[0]}.default`;

  // TODO: Move this to a Hook
  const isInContractPath = () => {
    return Object.values(t('common:url.contracts', {returnObjects: true, ...params}))
      .map(type => Object.values(type).includes(pathname))
      .some(val => val === true)
  }

  const detailsButtons = () => {
    return <>
      <DrawerItem
        icon={<MapsHomeWork />}
        label={t('common:text.contracts_title')}
        onClick={() => navigate(t(firstContractPath))}
        selected={isInContractPath()}
      />
      <DrawerItem
        icon={<Receipt />}
        label={t('common:text.invoices_title')}
        onClick={() => navigate(t('common:url.invoices'))}
        selected={location.pathname == t('common:url.invoices')}
      />
    </>
  }

  const openIdButtons = () => {
    return (!newCustomer ?
      <>
        <DrawerItem
          icon={<MapsHomeWork />}
          label={t('common:text.contracts_title')}
          onClick={() => navigate(t(firstContractPath))}
          selected={isInContractPath()}
        />
        <DrawerItem
          icon={<Receipt />}
          label={t('common:text.invoices_title')}
          onClick={() => navigate(t('common:url.invoices'))}
          selected={location.pathname == t('common:url.invoices')}
        />
      </>
    :
      <ContractationListItems />
    )
  }

  return <>
    {Settings.features?.oidc && openIdButtons()}
    {!Settings.features?.oidc && detailsButtons()}

    {Settings.features?.enableServerElements &&
      <DinamicServerNavigation
        clickableComponent={({children, linkInfo, onClick, ...props}) => {
          return (
            <DrawerItem
              label={linkInfo.btnTitle}
              selected={location.pathname.includes(linkInfo.routePath)}
              icon={<SpaceDashboard />}
              onClick={onClick}
            />
          )
        }}
      />
    }
  </>
}
